const rqParams = {
  /**
   * @description 学生-获取我加入的班级
   */
  getStudentJoinClass(params) {
    return {
      op_path: 'yjclass.classinfo.getstudentjoinclass',
      ...params
    }
  },
  /**
   * @description 学生-加入班级
   */
  submitStudentJoinClass(params) {
    return {
      op_path: 'yjclass.classinfo.submitstudentjoinclass',
      noJumpTo: true,
      ...params
    }
  },
  /**
   * @description 学生-设置当前班级
   */
  setStudentClassCurrent(params) {
    return {
      op_path: 'yjclass.classinfo.setstudentclasscurrent',
      noJumpTo: true,
      ...params
    }
  }
}
export default rqParams
